export default __webpack_public_path__ + "static/media/Cover_2_0682_IMG5698.36cf4440.jpg";